module.exports = __webpack_public_path__ + "img/level_three_lock.d977fe51.png";